import axiosInstance from "../../utils/axiosInstance";

const teamMemberService = {

    getList: async (page = 1, pageSize = 10, search = "") => {

        const response = await axiosInstance.get("/TeamMember", {
            params: {
                page,
                pageSize,
                search
            }
        });

        return response.data;
    },

    getById: async (id) => {

        const response = await axiosInstance.get(`/TeamMember/${id}`);

        return response.data;
    },

    create: async (data) => {

        const response = await axiosInstance.post(
            "/TeamMember",
            data
        );

        return response.data;
    },

    update: async (id, data) => {

        const response = await axiosInstance.put(
            `/TeamMember/${id}`,
            data
        );

        return response.data;
    },

    delete: async (id) => {

        const response = await axiosInstance.delete(
            `/TeamMember/${id}`
        );

        return response.data;
    }

};

export default teamMemberService;